export default __webpack_public_path__ + "static/media/onePlug.a8074528.svg";